import * as Constants from '../constants/promotion';

export const searchBrand = ($http, ENV, params) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.SEARCH_BRAND_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/1.0/brands/`,
      params,
    })
      .then((res) => {
        dispatch({ type: Constants.SEARCH_BRAND_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.SEARCH_BRAND_FAILED, payload: error });
        reject(error);
      });
  });

export const searchBrandByUrl = ($http, url) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.SEARCH_BRAND_BY_URL_REQUEST });

    $http({
      method: 'GET',
      url,
    })
      .then((res) => {
        dispatch({ type: Constants.SEARCH_BRAND_BY_URL_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.SEARCH_BRAND_BY_URL_FAILED, payload: error });
        reject(error);
      });
  });

const processProducts = (data) => {
  const { products, ...meta } = data;
  const newProducts = [];

  products.forEach((product) => {
    const { skus, ...productInfo } = product;
    skus.forEach((sku) => {
      newProducts.push({
        ...productInfo,
        skus: sku,
      });
    });
  });

  return {
    ...meta,
    products: newProducts,
  };
};

export const searchProduct = ($http, ENV, params) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.SEARCH_PRODUCT_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/1.0/products/`,
      params,
    })
      .then((res) => {
        const payload = processProducts(res.data);
        dispatch({ type: Constants.SEARCH_PRODUCT_SUCCESS, payload });
        resolve(payload);
      })
      .catch((error) => {
        dispatch({ type: Constants.SEARCH_PRODUCT_FAILED, payload: error });
        reject(error);
      });
  });

export const searchProductByUrl = ($http, url) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.SEARCH_PRODUCT_BY_URL_REQUEST });

    $http({
      method: 'GET',
      url,
    })
      .then((res) => {
        const payload = processProducts(res.data);
        dispatch({ type: Constants.SEARCH_PRODUCT_BY_URL_SUCCESS, payload });
        resolve(payload);
      })
      .catch((error) => {
        dispatch({ type: Constants.SEARCH_PRODUCT_BY_URL_FAILED, payload: error });
        reject(error);
      });
  });

export const getPromotionCode = ($http, ENV, promotionCodeId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_PROMOTION_CODE_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/promotion-codes/${promotionCodeId}/`,
    })
      .then((res) => {
        dispatch({
          type: Constants.GET_PROMOTION_CODE_SUCCESS,
          payload: res.data['promotion-code'],
        });
        resolve(res.data['promotion-code']);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_PROMOTION_CODE_FAILED, payload: error });
        reject(error);
      });
  });

export const createPromotionCode = ($http, ENV, data) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.CREATE_PROMOTION_CODE_REQUEST });

    $http({
      method: 'POST',
      url: ENV.apiEndpoint + `/2.0/promotion-codes/`,
      data,
    })
      .then((res) => {
        dispatch({ type: Constants.CREATE_PROMOTION_CODE_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.CREATE_PROMOTION_CODE_FAILED, payload: error });
        reject(error);
      });
  });

export const updatePromotionCode = ($http, ENV, data, promotionCodeId) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.UPDATE_PROMOTION_CODE_REQUEST });

    $http({
      method: 'PUT',
      url: ENV.apiEndpoint + `/2.0/promotion-codes/${promotionCodeId}/`,
      data,
    })
      .then((res) => {
        dispatch({ type: Constants.UPDATE_PROMOTION_CODE_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.UPDATE_PROMOTION_CODE_FAILED, payload: error });
        reject(error);
      });
  });

export const setActivePromotionCode = (code) => ({
  type: Constants.SET_ACTIVE_PROMOTION_CODE,
  payload: code,
});
